<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <el-skeleton-item variant="image" class="sk__image" />
      <div class="sk__block">
        <el-skeleton-item variant="p" class="sk__name" />
        <el-skeleton-item variant="p" class="sk__price" />
      </div>
    </template>
  </el-skeleton>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.sk {
  width: 100%;
  border-top: 1px solid $black;
  padding-top: 20px;
  display: flex;
  align-items: flex-start;
  gap: 50px;

  &__image {
    width: 328px;
    height: 412px;
    border-radius: 20px;
    flex-shrink: 0;
  }

  &__block {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  &__name {
    width: 80%;
    height: 50px;
  }

  &__price {
    width: 50%;
    height: 50px;
  }
}
</style>